import styled, { keyframes } from "styled-components";

// NOTE:
// Animating `background-position` on a full-screen gradient triggers expensive repaints.
// We instead animate a pseudo-element via `transform` (GPU-friendly) to keep motion
// without tanking performance.
const gradientDrift = keyframes`
  0% {
    transform: translate3d(-6%, -4%, 0) scale(1.1);
  }
  50% {
    transform: translate3d(6%, 4%, 0) scale(1.12);
  }
  100% {
    transform: translate3d(-6%, -4%, 0) scale(1.1);
  }
`;

const float1 = keyframes`
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  33% {
    transform: translate(30px, -30px) scale(1.05);
    opacity: 0.9;
  }
  66% {
    transform: translate(-20px, 20px) scale(0.95);
    opacity: 0.85;
  }
`;

const float2 = keyframes`
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  33% {
    transform: translate(-25px, 25px) scale(1.03);
    opacity: 0.9;
  }
  66% {
    transform: translate(35px, -20px) scale(0.97);
    opacity: 0.85;
  }
`;

const float3 = keyframes`
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  33% {
    transform: translate(20px, 30px) scale(0.98);
    opacity: 0.9;
  }
  66% {
    transform: translate(-30px, -25px) scale(1.02);
    opacity: 0.85;
  }
`;

const float4 = keyframes`
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }
  33% {
    transform: translate(-35px, -20px) scale(1.04);
    opacity: 0.9;
  }
  66% {
    transform: translate(25px, 30px) scale(0.96);
    opacity: 0.85;
  }
`;

export const GradientContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  background: var(--gradient-login, linear-gradient(135deg, #141414 0%, #1B72FF 50%, #00B5D9 100%));
  pointer-events: none;
  contain: paint;
  transform: translateZ(0);

  &::before {
    content: "";
    position: absolute;
    inset: -20%;
    background: var(--gradient-login, linear-gradient(135deg, #141414 0%, #1B72FF 50%, #00B5D9 100%));
    will-change: transform;
    transform: translate3d(0, 0, 0) scale(1.1);
    animation: ${gradientDrift} 60s ease-in-out infinite;
  }

  /* Keep SVG above the gradient layer */
  & > svg {
    position: relative;
    z-index: 1;
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none !important;
      transform: none !important;
    }
  }
`;

export const GradientSVG = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
  will-change: transform;
  transform: translateZ(0);
  
  /*
   * The SVG uses heavy filters (blur + turbulence). Animating those groups forces
   * filter re-evaluation each frame and hurts performance. Keep them static.
   */

  @media (prefers-reduced-motion: reduce) {
    animation: none !important;
    transform: none !important;
  }
`;
